import React from 'react';
import { Layout, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Layout className="min-h-full flex items-center justify-center">
      <Result status="404" title="404" subTitle={t('error.notFound')} />
    </Layout>
  );
};
